export type VoucherStatus = {
    bankId: string;
    id: string;
    purchased: number;
    remained: number;
    used: number;
};

export type VoucherHistory = {
    firstName: string;
    lastName: string;
    lastSendDate: Date;
    companyName: string;
    mail: string;
    ndg: string | null;
    phone: string;
    taxCode: string | null;
    type: VoucherUserType;
    vatCode: string;
    voucherExpireDate: Date;
    voucherId: string;
    voucherRegisteredEndDate: Date;
    voucherRegisteredStartDate: Date;
    voucherState: VoucherState;
}

export type ResendVoucherRequest = {
    bankId: string;
    voucherId: string; 
}

export type SendVoucherRequest = {
    mail: string;
    firstName: string; 
    lastName: string;
    companyName: string;
    phone: string; 
    type: VoucherUserType; 
    ndg: string; 
    vatCode: string; 
    taxCode: string; 
    bankId: string;
}

export enum VoucherUserType
{
    Client = 0,
    Prospect = 1
}

export type VoucherState = 'Registered' | 'Sended' | 'Cancelled' | 'VoucherExpired' | 'RegistrationExpired';

export const voucherType = {
    'Cliente': 0,
    'Prospect': 1
};

export const voucherState = {
    Registered: 'Registrato',
    Sended: 'Inviato',
    Cancelled: 'Annullato',
    VoucherExpired: 'Voucher Scaduto',
    RegistrationExpired: 'Registrazione Scaduta'
};

export type UseVoucherResponse = {
    code: string;
    endpoint:string | null;
    message:string;
    status: number | string;
}